const AnimationMode = {
	Full: "full",
	Basic: "basic",
	Minimal: "minimal",
	None: "none",
};
export default AnimationMode;
